import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedDate } from 'react-intl';
import {
	Grid,
	IconButton,
	ListItemAvatar,
	ListItemSecondaryAction,
	ListItemText,
	Tooltip,
	Typography
} from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, ImageAvatar, SquareChip, Text, Utils, useSettings } from 'app/main/components';
import { showCoursesAttendersRemoveDialog } from './CoursesAttendersRemoveDialog';

export default function CoursesAttendersListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	function remove() {
		dispatch(
			showCoursesAttendersRemoveDialog({
				model: props.model,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);
	}

	const button = (
		<ListItemSecondaryAction className="relative right-0 top-0 transform-none self-center">
			<Tooltip title={t('COURSES_BUTTON_REMOVE_ATTENDER')} arrow>
				<IconButton onClick={remove}>
					<Icon icon="account-remove" />
				</IconButton>
			</Tooltip>
		</ListItemSecondaryAction>
	);

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.crus_user_uid}
			avatar={props.model.user_avatar}
			initials={props.model.user_title_initials}
		/>
	);
	return (
		<GridListItem avatar={avatar} secondaryAction={button}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 720 ? 6 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'users', uid: props.model.crus_user_uid }}
							>
								{props.model.user_title}
							</Text>
						</Grid>
						<Grid>
							{/* ROLES */}
							{props.model.user_duties?.map(role => (
								<SquareChip
									key={role.usda_id}
									label={role.usdt_title}
									backgroundColor={role.usdt_color}
								/>
							))}
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ xs: props.width >= 720 ? 6 : 12 }}>
					<Typography color="text.secondary" variant="subtitle2">
						{props.model.crus_d_created ? (
							<FormattedDate
								value={Utils.parseDate(props.model.crus_d_created)?.toDate()}
								year="numeric"
								month="2-digit"
								day="2-digit"
								hour="2-digit"
								minute="numeric"
							/>
						) : (
							t('VIEW_ITEM_NO_DATES')
						)}
					</Typography>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
